export default "__VITE_ASSET__4e328772__"